import React, { useState } from 'react';
import './CustomHoverBox.css';
import DocIcon from '../../images/icons/doc_icon.svg';
import VerifyIcon from '../../images/icons/verified.svg';
import NotStarted from '../../images/icons/not_started.svg';
import NotVerified from '../../images/icons/not_verified.svg';
import VerifyFailed from '../../images/icons/verification_failed.svg';
import window from 'window-or-global';

function DefinedDocs (props)  {
  let DocImage = DocIcon,
    opacity,
    width = '65%',
    StatusIcon,
    background = '#F8FDFD',
    message = '',
    message_color = 'black';

  if (window.innerWidth < 768) {
    width = '100%';
    try {
      if (props.doc.curent_page) {
        opacity = '1';
      } else {
        opacity = '0.2';
      }
    } catch {
      opacity = '0.2';
    }
  }

  if (props.doc.curent_page) {
    if (props.fullWidth) {
      width = '100%';
    } else {
      width = '83%';
    }
    background = 'white';
  }

  if (props.doc.verified === 'NOT_INITIATED') {
    StatusIcon = NotStarted;
    message = 'The step is not started yet';
  } else if (props.doc.verified === 'PENDING') {
    StatusIcon = NotVerified;
    message = 'Verification is Pending';
    message_color = 'orange';
  } else if (props.doc.verified === 'APPROVED') {
    StatusIcon = VerifyIcon;
    message = 'Document is verified successfully';
    message_color = 'green';
  } else if (props.doc.verified === 'REJECTED') {
    StatusIcon = VerifyFailed;
    message = 'Verification Failed';
    message_color = 'red';
  }

  try {
    if (props.doc.DocIcon) {
      DocImage = props.doc.DocIcon;
    }
  } catch {
    DocImage = DocIcon;
  }
  try {
    if (props.doc.opacity) {
      opacity = props.doc.opacity;
    }
  } catch {
    opacity = '1';
  }
  const onHover = (instanceOfMouseEvent, id) => {
    let tooltipSpan = document.getElementById(id);
    var x = instanceOfMouseEvent.pageX;
    tooltipSpan.style.left = x - 224 + 'px';
  };
  return (
    <div
      className=" relative w-full flex-shrink-0 flex  mt-5 px-3 hover:visible"
      onMouseEnter={event => onHover(event, 'top_' + props.doc.id)}
      onClick={() => props.click(props.doc.id)}
    >
      <div className=" w-2/12 hidden md:block text-right items-center md:mr-4">
        <img
          className="w-4 pt-4 ml-auto"
          src={StatusIcon}
          alt="verified"
          id={props.doc.id + '_image'}
        />
      </div>
      <div
        className="tooltip flex mb-2 rounded items-center pl-5 shadow  bg-white pr-4 "
        style={{ width: width, backgroundColor: background }}
      >
        <div
          id={'top_' + props.doc.id}
          className="top text-white bg-white font-normal text-xs rounded-md absolute z-50 box-border hidden "
        >
          <p id={props.doc.id + '_message'} style={{ color: message_color }}>
            {message}
          </p>
          <i className="absolute overflow-hidden"></i>
        </div>

        <p
          className="blxock md:hidden mr-4 font-roboto text-medium text-sm"
          style={{ opacity: opacity }}
        >
          {props.doc.val_init}
        </p>
        <img
          className="w-10 py-3 h-auto mr-3 md:mr-0"
          src={DocImage}
          alt="doc"
        />
        <p
          className="ml-3 font-roboto text-black-600 tracking-normal text-sm opacity-100 font-medium md:text-xs lg:text-sm"
          style={{ opacity: opacity }}
        >
          {props.doc.name}
        </p>
      </div>
    </div>
  );
};
export default DefinedDocs;
